export const CANCEL_CARD_ATTEMPT = 'account/CANCEL_CARD_ATTEMPT';
export const CANCEL_CARD_CONFIRM = 'account/CANCEL_CARD_CONFIRM';
export const CANCEL_CARD_REJECT = 'account/CANCEL_CARD_REJECT';
export const CANCEL_CARD_SUCCESS = 'account/CANCEL_CARD_SUCCESS';
export const CANCEL_CARD_FAILURE = 'account/CANCEL_CARD_FAILURE';

export const cancelCardAttempt = () => ({
  type: CANCEL_CARD_ATTEMPT
});
export const cancelCardConfirm = () => ({
  type: CANCEL_CARD_CONFIRM
});
export const cancelCardReject = () => ({
  type: CANCEL_CARD_REJECT
});
export const cancelCardSuccess = () => ({
  type: CANCEL_CARD_SUCCESS
});
export const cancelCardFailure = (error) => ({
  type: CANCEL_CARD_FAILURE,
  error
});
